import { __makeTemplateObject, __read } from "tslib";
import React, { useEffect, useRef, useState, useCallback } from 'react';
import styled from 'styled-components';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
// TODO
//
// - throttle/RAF/perf?
// - types (easier after Paolo's changes merged)
// - prevent scrollbars overlapping when fully scrolled in both directions
// - polyfill smooth scroll?
// - use state instead of refs -- can't quite remember why I'm positioning the
//   scrollbars with refs for example
var ScrollbarThumb = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 6px;\n  position: absolute;\n  user-select: none;\n  opacity: ", ";\n  transition: opacity 300ms ease-in-out;\n\n  &:hover {\n    background-color: #999;\n    opacity: 0.6;\n  }\n"], ["\n  background-color: ", ";\n  border-radius: 6px;\n  position: absolute;\n  user-select: none;\n  opacity: ", ";\n  transition: opacity 300ms ease-in-out;\n\n  &:hover {\n    background-color: #999;\n    opacity: 0.6;\n  }\n"])), function (props) { return (props.dragging ? '#999' : '#aaa'); }, function (props) { return (props.dragging ? 0.6 : 0); });
var VerticalScrollbarThumb = styled(ScrollbarThumb)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 6px;\n  top: 0px;\n  right: 2px;\n  height: ", "px;\n"], ["\n  width: 6px;\n  top: 0px;\n  right: 2px;\n  height: ", "px;\n"])), function (props) { return props.height; });
var HorizontalScrollbarThumb = styled(ScrollbarThumb)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 6px;\n  bottom: 2px;\n  left: 0px;\n  width: ", "px;\n"], ["\n  height: 6px;\n  bottom: 2px;\n  left: 0px;\n  width: ", "px;\n"])), function (props) { return props.width; });
export var ScrollbarContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  user-select: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  &:hover {\n    + div.thumbWrapper {\n      ", " {\n        opacity: 0.6;\n      }\n      ", " {\n        opacity: 0.6;\n      }\n    }\n  }\n"], ["\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  user-select: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  &:hover {\n    + div.thumbWrapper {\n      ", " {\n        opacity: 0.6;\n      }\n      ", " {\n        opacity: 0.6;\n      }\n    }\n  }\n"])), VerticalScrollbarThumb, HorizontalScrollbarThumb);
export function Scrollbars(_a) {
    var 
    // We could measure these values but for our use case we don't need to as
    // they're already known for the parent component
    containerWidth = _a.containerWidth, containerHeight = _a.containerHeight, contentWidth = _a.contentWidth, contentHeight = _a.contentHeight, containerTop = _a.containerTop, containerLeft = _a.containerLeft, onMouseDown = _a.onMouseDown, allowedDirections = _a.allowedDirections, horizontalScrollbar = _a.horizontalScrollbar, verticalScrollbar = _a.verticalScrollbar, horizontalScrollbarSize = _a.horizontalScrollbarSize, verticalScrollbarSize = _a.verticalScrollbarSize, _b = _a.hasScrollbars, hasScrollbars = _b === void 0 ? true : _b, scrollDirection = _a.scrollDirection, isScrolling = _a.isScrolling;
    if (!hasScrollbars)
        return null;
    return (React.createElement("div", { className: "thumbWrapper" },
        allowedDirections !== 'vertical' && containerWidth < contentWidth && (React.createElement("div", { style: {
                position: 'absolute',
                top: containerTop + containerHeight,
                left: containerLeft,
            } },
            React.createElement(HorizontalScrollbarThumb, { dragging: scrollDirection === 'horizontal' || isScrolling, onMouseDown: onMouseDown, ref: horizontalScrollbar, width: horizontalScrollbarSize }))),
        allowedDirections !== 'horizontal' && containerHeight < contentHeight && (React.createElement("div", { style: {
                position: 'absolute',
                top: containerTop,
                left: containerLeft + containerWidth,
            } },
            React.createElement(VerticalScrollbarThumb, { "data-testid": "vertical-scrollbar-thumb", dragging: scrollDirection === 'vertical' || isScrolling, height: verticalScrollbarSize, onMouseDown: onMouseDown, ref: verticalScrollbar })))));
}
export function useScrollbars(_a) {
    var containerRef = _a.containerRef, containerWidth = _a.containerWidth, containerHeight = _a.containerHeight, contentWidth = _a.contentWidth, contentHeight = _a.contentHeight, containerTop = _a.containerTop, containerLeft = _a.containerLeft, snap = _a.snap, allowedDirections = _a.allowedDirections, hasScrollbars = _a.hasScrollbars;
    var start = useRef({});
    var _b = __read(useState(null), 2), scrollDirection = _b[0], setScrollDirection = _b[1];
    var _c = __read(useState(false), 2), isScrolling = _c[0], setIsScrolling = _c[1];
    var scrollStopTimeout = useRef();
    var dragStatus = useRef(null);
    var dragged = useRef(false);
    var waitingOnScroll = useRef(null);
    var dragElement = useRef(null);
    var horizontalScrollbar = useRef();
    var verticalScrollbar = useRef();
    var horizontalScrollbarSize = (containerWidth / contentWidth) * containerWidth;
    var verticalScrollbarSize = (containerHeight / contentHeight) * containerHeight;
    function onContainerMouseDown(e) {
        // TODO factor out common code with onMouseDown
        dragElement.current = 'container';
        dragStatus.current = 'start';
        dragged.current = false; // we don't yet know if this will be a drag or just click
        start.current.mouse = { x: e.pageX, y: e.pageY };
        start.current.container = {
            scrollTop: containerRef.current.scrollTop,
            scrollLeft: containerRef.current.scrollLeft,
        };
        setScrollDirection('both');
    }
    function onMouseDown(e) {
        e.preventDefault(); // prevent drag scroll in Safari
        e.stopPropagation();
        dragElement.current = 'scrollbar';
        dragStatus.current = 'start';
        dragged.current = false; // we don't yet know if this will be a drag or just click
        start.current.mouse = { x: e.pageX, y: e.pageY };
        if (verticalScrollbar.current) {
            start.current.vertical =
                verticalScrollbar.current.getBoundingClientRect().top -
                    containerRef.current.getBoundingClientRect().top;
        }
        if (horizontalScrollbar.current) {
            start.current.horizontal =
                horizontalScrollbar.current.getBoundingClientRect().left -
                    containerRef.current.getBoundingClientRect().left;
        }
        start.current.container = {
            scrollTop: containerRef.current.scrollTop,
            scrollLeft: containerRef.current.scrollLeft,
        };
        setScrollDirection(e.target === horizontalScrollbar.current ? 'horizontal' : 'vertical');
    }
    var syncScrollbarsWithScrollPosition = useCallback(function () {
        // sync scrollbar position with container scroll position
        var p = containerRef.current.scrollTop / contentHeight;
        var top = containerHeight * p;
        if (verticalScrollbar.current) {
            verticalScrollbar.current.style.transform = "translateY(" + top + "px)";
        }
        p = containerRef.current.scrollLeft / contentWidth;
        var left = containerWidth * p;
        // sync scrollbar position with container scroll position
        if (horizontalScrollbar.current) {
            horizontalScrollbar.current.style.transform = "translateX(" + left + "px)";
        }
        if (waitingOnScroll.current !== null &&
            (waitingOnScroll.current.leftSnap === undefined ||
                containerRef.current.scrollLeft === waitingOnScroll.current.leftSnap) &&
            (waitingOnScroll.current.topSnap === undefined ||
                containerRef.current.scrollTop === waitingOnScroll.current.topSnap)) {
            waitingOnScroll.current = null;
            setScrollDirection(null);
        }
    }, [
        containerHeight,
        containerRef,
        containerWidth,
        contentHeight,
        contentWidth,
    ]);
    function onScroll() {
        if (!isScrolling) {
            setIsScrolling(true);
        }
        if (scrollStopTimeout.current) {
            clearTimeout(scrollStopTimeout.current);
        }
        scrollStopTimeout.current = setTimeout(function () { return setIsScrolling(false); }, 300);
        syncScrollbarsWithScrollPosition();
    }
    useEffect(function () {
        function mouseMove(e) {
            if (dragStatus.current === 'end') {
                return;
            }
            dragStatus.current = 'dragging';
            dragged.current = true;
            var pageX = e.pageX, pageY = e.pageY;
            var delta = {
                horizontal: pageX - start.current.mouse.x,
                vertical: pageY - start.current.mouse.y,
            };
            if (dragElement.current === 'container') {
                drag(delta);
            }
            else {
                scroll(scrollDirection, delta[scrollDirection]);
            }
        }
        function drag(delta) {
            if (allowedDirections !== 'vertical') {
                // eslint-disable-next-line no-param-reassign
                containerRef.current.scrollLeft =
                    start.current.container.scrollLeft - delta.horizontal;
            }
            if (allowedDirections !== 'horizontal') {
                // eslint-disable-next-line no-param-reassign
                containerRef.current.scrollTop =
                    start.current.container.scrollTop - delta.vertical;
            }
        }
        function mouseUp() {
            dragStatus.current = 'end';
            if (snap) {
                snapScroll();
                if (!waitingOnScroll.current) {
                    setScrollDirection(null);
                }
            }
            else {
                setScrollDirection(null);
            }
        }
        function snapScroll() {
            // snap in js because safari is 💩
            var _a = containerRef.current, scrollLeft = _a.scrollLeft, scrollTop = _a.scrollTop;
            var leftSnap = allowedDirections !== 'vertical'
                ? snapPosition(scrollLeft, containerWidth, contentWidth)
                : undefined;
            var topSnap = allowedDirections !== 'horizontal'
                ? snapPosition(scrollTop, containerHeight, contentHeight)
                : undefined;
            if ((leftSnap === undefined || leftSnap === scrollLeft) &&
                (topSnap === undefined || topSnap === scrollTop)) {
                return;
            }
            if (containerRef.current.scrollTo) {
                waitingOnScroll.current = { topSnap: topSnap, leftSnap: leftSnap };
                containerRef.current.scrollTo({
                    left: leftSnap,
                    top: topSnap,
                    behavior: 'smooth',
                });
            }
            else {
                // IE11
                // eslint-disable-next-line no-param-reassign
                if (leftSnap !== undefined)
                    containerRef.current.scrollLeft = leftSnap;
                // eslint-disable-next-line no-param-reassign
                if (topSnap !== undefined)
                    containerRef.current.scrollTop = topSnap;
            }
        }
        var handleClickCapture = function (e) {
            // prevent click propagating and triggering hotspot flash after scrolling
            if (
            // always swallow click on a scrollbar
            dragElement.current === 'scrollbar' ||
                // swallow click if a drag occurred
                dragged.current) {
                e.stopPropagation();
                e.preventDefault();
            }
        };
        function scroll(direction, delta) {
            var _a = getScrollAttributes(direction), translate = _a.translate, scrollSize = _a.scrollSize, scrollProp = _a.scrollProp, scrollbarRef = _a.scrollbarRef, containerSize = _a.containerSize, scrollbarSize = _a.scrollbarSize;
            var scrollbarPosition = start.current[direction];
            scrollbarPosition = start.current[direction] + delta;
            scrollbarPosition = Math.min(scrollbarPosition, containerSize - scrollbarSize);
            scrollbarPosition = Math.max(0, scrollbarPosition);
            scrollbarRef.current.style.transform = translate + "(" + scrollbarPosition + "px)";
            var pp = delta / containerSize;
            var newScrollPos = start.current.container[scrollProp] +
                pp * containerRef.current[scrollSize];
            // eslint-disable-next-line no-param-reassign
            containerRef.current[scrollProp] = newScrollPos;
        }
        function getScrollAttributes(direction) {
            if (direction === 'vertical') {
                return {
                    translate: 'translateY',
                    scrollSize: 'scrollHeight',
                    scrollProp: 'scrollTop',
                    scrollbarRef: verticalScrollbar,
                    scrollbarSize: verticalScrollbarSize,
                    containerSize: containerHeight,
                };
            }
            return {
                translate: 'translateX',
                scrollSize: 'scrollWidth',
                scrollProp: 'scrollLeft',
                scrollbarRef: horizontalScrollbar,
                scrollbarSize: horizontalScrollbarSize,
                containerSize: containerWidth,
            };
        }
        if (scrollDirection) {
            document.addEventListener('mousemove', mouseMove);
            document.addEventListener('mouseup', mouseUp);
            document.addEventListener('click', handleClickCapture, true);
        }
        return function () {
            document.removeEventListener('mousemove', mouseMove);
            document.removeEventListener('mouseup', mouseUp);
            document.removeEventListener('click', handleClickCapture, true);
        };
    }, [
        allowedDirections,
        containerHeight,
        containerRef,
        containerWidth,
        contentHeight,
        contentWidth,
        horizontalScrollbarSize,
        scrollDirection,
        snap,
        verticalScrollbarSize,
    ]);
    return {
        onMouseDown: onMouseDown,
        onContainerMouseDown: onContainerMouseDown,
        onContainerScroll: onScroll,
        scrollDirection: scrollDirection,
        allowedDirections: allowedDirections,
        isDragging: scrollDirection !== null,
        isScrolling: isScrolling,
        verticalScrollbar: verticalScrollbar,
        horizontalScrollbar: horizontalScrollbar,
        horizontalScrollbarSize: horizontalScrollbarSize,
        verticalScrollbarSize: verticalScrollbarSize,
        containerTop: containerTop,
        containerLeft: containerLeft,
        containerWidth: containerWidth,
        containerHeight: containerHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        hasScrollbars: hasScrollbars,
    };
}
function snapPosition(position, containerWidth, contentWidth) {
    var roundedContentSizeMultiple = Math.round(position / containerWidth);
    return Math.min(roundedContentSizeMultiple * containerWidth, contentWidth - containerWidth);
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
